import { useEffect, useState } from "react";
import api from "../lib/api";
import { Button } from "./ui/button";
import { Input } from "./ui/input";
import { Label } from "./ui/label";
import { Switch } from "./ui/switch";
import { Card, CardHeader, CardTitle, CardDescription, CardContent } from "./ui/card";
import { toast } from "sonner";
import { Sparkles } from "lucide-react";

export function AdminAISettings() {
  const [enabled, setEnabled] = useState(true);
  const [quota, setQuota] = useState("10");
  const [saving, setSaving] = useState(false);

  useEffect(() => {
    api.get("/admin/config").then(({ data }) => {
      setEnabled(data.ai_enabled !== false);
      setQuota(String(data.ai_daily_quota ?? 10));
    }).catch(() => {});
  }, []);

  const save = async () => {
    setSaving(true);
    try {
      await api.put("/admin/config", { ai_enabled: enabled, ai_daily_quota: parseInt(quota, 10) });
      toast.success("Paramètres IA enregistrés");
    } catch (e) {
      toast.error(e.response?.data?.detail || "Erreur");
    } finally {
      setSaving(false);
    }
  };

  return (
    <Card className="max-w-2xl mt-6" data-testid="admin-ai-settings">
      <CardHeader>
        <CardTitle className="flex items-center gap-2"><Sparkles className="h-5 w-5" /> Assistant IA (descriptions)</CardTitle>
        <CardDescription>Aide à la rédaction des descriptions de cagnottes et tontines (Gemini)</CardDescription>
      </CardHeader>
      <CardContent className="space-y-4">
        <div className="flex items-center justify-between gap-4">
          <Label htmlFor="ai-enabled">Assistant IA activé</Label>
          <Switch id="ai-enabled" checked={enabled} onCheckedChange={setEnabled} data-testid="cfg-ai-enabled" />
        </div>
        <div className="space-y-2">
          <Label htmlFor="ai-quota">Quota par utilisateur et par jour</Label>
          <Input id="ai-quota" type="number" min="0" max="1000" value={quota} onChange={(e) => setQuota(e.target.value)} data-testid="cfg-ai-quota" />
        </div>
        <Button onClick={save} disabled={saving} className="btn-gradient rounded-full" data-testid="save-ai-config-btn">Enregistrer les paramètres IA</Button>
      </CardContent>
    </Card>
  );
}
